import { render, staticRenderFns } from "./GridCompetenciesCrud.vue?vue&type=template&id=01a77f4a&scoped=true"
import script from "./GridCompetenciesCrud.vue?vue&type=script&lang=js"
export * from "./GridCompetenciesCrud.vue?vue&type=script&lang=js"
import style0 from "./GridCompetenciesCrud.vue?vue&type=style&index=0&id=01a77f4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a77f4a",
  null
  
)

export default component.exports